import React from 'react';
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';

const borderColor = '#AAAAAA';
const specialBorderColor = '#F3F3F4';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
        border: `1px solid ${borderColor}`,
        color: '#555555',
        // verticalAlign: 'baseline',
    },
    '&.bold-text': {
        fontWeight: 700,
    },
    width: '43%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    '&:first-child': {
        borderLeft: `1px solid ${specialBorderColor}`,
        width: '0px !important',
    },
    '&:last-child': {
        borderRight: `1px solid ${specialBorderColor}`,
    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: '#CCE5E5',
    }
}));

const SecurityModuleTable = ({
    tableHeader, tableBody
}) => {
    return (
        <TableContainer>
            <Table aria-label="customized table">
                <TableRow>
                    {
                        tableHeader && tableHeader.map((elem) => {
                            return (
                                <StyledTableCell sx={{ fontWeight: "bold", textAlign: "center" }}>{elem}</StyledTableCell>
                            )
                        })
                    }

                </TableRow>

                <TableBody>
                    {tableBody && tableBody.map((row) => {
                        return (
                            <>
                                {row && row?.subHeading?.map((elem) => {
                                    return (
                                        <TableRow>
                                            <StyledTableCell sx={{ fontWeight: "bold" }}>{elem && elem.sno}</StyledTableCell>
                                            <StyledTableCell sx={{ fontWeight: "bold", textAlign: "center" }} colSpan={3}>{elem && elem.title}</StyledTableCell>
                                        </TableRow>
                                    )
                                })}
                                {row && row?.data?.map((elem) => {
                                    return (
                                        <StyledTableRow>
                                            <StyledTableCell></StyledTableCell>
                                            <StyledTableCell>{elem && elem.pictorial}</StyledTableCell>
                                            <StyledTableCell>{elem && elem.functional}</StyledTableCell>
                                            <StyledTableCell>{elem && elem.essential}</StyledTableCell>
                                        </StyledTableRow>
                                    )
                                })}
                            </>
                        )
                    })}
                </TableBody>
            </Table>
        </TableContainer >
    );
}

export default SecurityModuleTable;